import { render, staticRenderFns } from "./DetailSnapshot.vue?vue&type=template&id=15bb0642&scoped=true&"
import script from "./DetailSnapshot.vue?vue&type=script&lang=js&"
export * from "./DetailSnapshot.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/custom-style.css?vue&type=style&index=0&id=15bb0642&scoped=true&lang=css&"
import style1 from "./DetailSnapshot.vue?vue&type=style&index=1&id=15bb0642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bb0642",
  null
  
)

export default component.exports